import React, { useState, useCallback, useEffect } from "react";
import { observer } from "mobx-react";
import { TextField, Select, Button } from "@ann/web-components";
import {
  FiltersContainerWrapper,
  FiltersColumn,
  SearchContainer,
} from "./FiltersContainer.styled";

const FiltersContainer = observer(
  ({
    loading,
    filters,
    filterHandlers,
    filterUI,
  }) => {
    const [localSearchValue, setLocalSearchValue] = useState(filters?.searchValue || "");

    // Desestructurar valores de los objetos agrupados
    const {
      statusOptions,
      typeOptions,
      categoryOptions,
      lastUpdateOptions,
      filteredStatus,
      filteredType,
      filteredCategory,
      filteredLastUpdate,
      selectedStatus,
      selectedType,
      selectedCategory,
      selectedLastUpdatePreset,
      searchValue,
      hasActiveFilters,
    } = filters;

    const {
      handleSearchChange,
      handleStatusChange,
      handleTypeChange,
      handleCategoryChange,
      handleLastUpdatePresetChange,
      handleClearFiltersWithKeys,
    } = filterHandlers;

    const {
      filtersKey,
      updateLocalSearch,
    } = filterUI;

    const handleSearchChangeCallback = useCallback((value) => {
      setLocalSearchValue(value);
      if (handleSearchChange) {
        handleSearchChange(value);
      }
    }, [handleSearchChange]);

    // Sync local state with filters when it changes
    useEffect(() => {
      setLocalSearchValue(searchValue || "");
    }, [searchValue]);

    return (
      <FiltersContainerWrapper>
        <FiltersColumn>
          <SearchContainer>
            <TextField
              iconLeft="search"
              onChange={handleSearchChangeCallback}
              size="small"
              placeholder="Search"
              value={localSearchValue}
              disabled={loading}
            />
          </SearchContainer>
          
          <Select
            key={`status-filter-${filtersKey}`}
            label="Status"
            placeholder="Status"
            onChange={handleStatusChange}
            size="small"
            value={
              selectedStatus.length > 0
                ? statusOptions.find((option) => option.value === selectedStatus[0]) || undefined
                : undefined
            }
            width="auto"
            minWidth="92px"
            disabled={loading}
          >
            <Select.Menu width="160px">
              <Select.Search
                placeholder="Search"
                onChange={(value) => updateLocalSearch("status", value)}
                label=""
              />
              {filteredStatus.map((option) => (
                <Select.Item
                  key={option.value}
                  value={option.value}
                  label={option.label}
                >
                  {option.label}
                </Select.Item>
              ))}
            </Select.Menu>
          </Select>
          
          <Select
            key={`type-filter-${filtersKey}`}
            label="Type"
            placeholder="Type"
            onChange={handleTypeChange}
            size="small"
            value={
              selectedType.length > 0
                ? typeOptions.find((option) => option.value === selectedType[0]) || undefined
                : undefined
            }
            width="auto"
            minWidth="92px"
            disabled={loading}
          >
            <Select.Menu width="160px">
              <Select.Search
                placeholder="Search"
                onChange={(value) => updateLocalSearch("type", value)}
                label=""
              />
              {filteredType.map((option) => (
                <Select.Item
                  key={option.value}
                  value={option.value}
                  label={option.label}
                >
                  {option.label}
                </Select.Item>
              ))}
            </Select.Menu>
          </Select>
          
          <Select
            key={`category-filter-${filtersKey}`}
            label="Category"
            placeholder="Category"
            onChange={handleCategoryChange}
            size="small"
            value={
              selectedCategory.length > 0
                ? categoryOptions.find((option) => option.value === selectedCategory[0]) || undefined
                : undefined
            }
            width="auto"
            minWidth="104px"
            disabled={loading}
          >
            <Select.Menu width="160px">
              <Select.Search
                placeholder="Search"
                onChange={(value) => updateLocalSearch("category", value)}
                label=""
              />
              {filteredCategory.map((option) => (
                <Select.Item
                  key={option.value}
                  value={option.value}
                  label={option.label}
                >
                  {option.label}
                </Select.Item>
              ))}
            </Select.Menu>
          </Select>

          <Select
            key={`last-update-filter-${filtersKey}`}
            label="Last Update"
            placeholder="Last Update"
            onChange={handleLastUpdatePresetChange}
            size="small"
            value={
              lastUpdateOptions.find((option) => option.value === selectedLastUpdatePreset) || undefined
            }
            width="auto"
            minWidth="141px"
            disabled={loading}
          >
            <Select.Menu width="160px">
              <Select.Search
                placeholder="Search"
                onChange={(value) => updateLocalSearch("lastUpdate", value)}
                label=""
              />
              {filteredLastUpdate.map((option) => (
                <Select.Item
                  key={option.value}
                  value={option.value}
                  label={option.label}
                >
                  {option.label}
                </Select.Item>
              ))}
            </Select.Menu>
          </Select>
          
          {hasActiveFilters && (
            <Button
              icon=""
              iconLeft=""
              iconRight=""
              label="Clear Filters"
              size="medium"
              type="secondary"
              onClick={handleClearFiltersWithKeys}
              disabled={loading}
            />
          )}
        </FiltersColumn>
      </FiltersContainerWrapper>
    );
  }
);

export default FiltersContainer;

